import styled from 'styled-components'

export default styled.div`
  display: inline-flex;

  .selector-container {
    position: relative;
  }

  .selector {
    font-family: 'ABChanel PB Regular S', Arial, sans-serif;
    font-size: 11px;
    width: 100px;
    height: 40px;
    margin-top: 0;
    margin-bottom: 0;
    margin-right: 16px;
    margin-left: 1px;
    padding-left: 8px;
    border: solid 1px #000000;
    border-radius: 0;
    background-color: #ffffff;
    appearance: none;
  }

  .select-dropdown {
    position: absolute;
    left: 80px;
    top: 18px;
  }
`



// WEBPACK FOOTER //
// ./src/styles/CountryCodeSelector.js